import {
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE,
    CLEAR_RESET_PASSWORD_STATE,
  } from '../actions/types';
  
  const initialState = {
    loading: false,
    successMessage: null,
    errorMessage: null,
  };
  
  export default function(state = initialState, action) {
    const { type, payload } = action;
  
    switch (type) {
      case RESET_PASSWORD_REQUEST:
        return {
          ...state,
          loading: true,
          successMessage: null,
          errorMessage: null,
        };
      case RESET_PASSWORD_SUCCESS:
        return {
          ...state,
          loading: false,
          successMessage: payload,
          errorMessage: null,
        };
      case RESET_PASSWORD_FAILURE:
        return {
          ...state,
          loading: false,
          successMessage: null,
          errorMessage: payload,
        };
      case CLEAR_RESET_PASSWORD_STATE:
        return {
          ...initialState, // Reset everything to the initial state
        };
      default:
        return state;
    }
  }